import React from 'react';
import { motion } from 'framer-motion';
import { EbookMockup } from './EbookMockup';
export function VisualImpact() {
  return <section className="relative py-24 bg-brand-dark text-white overflow-hidden" data-id="element-335">
      {/* Background Image */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=2000')] bg-cover bg-center opacity-15" data-id="element-336"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/95 to-brand-dark/80" data-id="element-337"></div>

      <div className="container mx-auto px-6 max-w-6xl relative z-10" data-id="element-338">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-339">
          {/* Text */}
          <motion.div className="flex-1 text-center lg:text-left" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-340">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-341">
              Toma el control de tu crédito con un sistema{' '}
              <span className="text-brand-gold" data-id="element-342">claro y probado</span>
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-343">
              Miles de personas en Estados Unidos luchan con su crédito porque
              nadie les enseñó cómo funciona. Este sistema cambia eso — con
              estrategias reales, herramientas prácticas y un camino claro hacia
              la estabilidad financiera.
            </p>
            <div className="grid grid-cols-3 gap-6 max-w-md mx-auto lg:mx-0" data-id="element-344">
              <div className="text-center" data-id="element-345">
                <div className="text-3xl font-bold text-brand-gold" data-id="element-346">20</div>
                <div className="text-xs text-gray-400 uppercase tracking-wider mt-1" data-id="element-347">
                  Módulos
                </div>
              </div>
              <div className="text-center" data-id="element-348">
                <div className="text-3xl font-bold text-brand-gold" data-id="element-349">2</div>
                <div className="text-xs text-gray-400 uppercase tracking-wider mt-1" data-id="element-350">
                  Bonos Premium
                </div>
              </div>
              <div className="text-center" data-id="element-351">
                <div className="text-3xl font-bold text-brand-gold" data-id="element-352">100%</div>
                <div className="text-xs text-gray-400 uppercase tracking-wider mt-1" data-id="element-353">
                  Práctico
                </div>
              </div>
            </div>
          </motion.div>

          {/* Mockup */}
          <motion.div className="flex-1" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-354">
            <EbookMockup data-id="element-355" />
          </motion.div>
        </div>
      </div>
    </section>;
}